import React, { useState, useEffect, useRef } from 'react';
import Utility from '../../../../Utility/Utility';
import CustomInput from '../../../../Utility/Components/CustomInput';
import moment from 'moment';

function TourPriceDetails({
    selectedTour,
    startDate,
    endDate,
    tourBookingPrice,
    calculatePrice,
    paymentDetailsDataSet,
    setPaymentDetailsDataSet,
    setSelectedTourData
}) {
    // console.log("tourBookingPrice==========", tourBookingPrice)
    // const [paymentDetailsDataSet, setPaymentDetailsDataSet] = useState({
    //     is_igst_enable: false,
    //     no_tax: false,
    // });
    const [taxChange, setTaxChange] = useState(false);
    const [currencyName, setCurrencyName] = useState("INR");
    const [specialDiscount, setSpecialDiscount] = useState("");
    const [specialRateSelectedValue, setSpecialRateSelectedValue] = useState("rate");

    //igst , cgst-sgst , tax field onchange fn
    const handleChangeIgstFn = (e, type) => {
        const { checked } = e.target;
        if (type === "cgst_sgst") {
            if (checked) {
                setPaymentDetailsDataSet((prevData) => ({
                    ...prevData,
                    is_igst_enable: false,
                }));
            }
        }
        if (type === "igst") {
            if (checked) {
                setPaymentDetailsDataSet((prevData) => ({
                    ...prevData,
                    is_igst_enable: true,
                }));
            }
        }
        if (type === "no_tax") {
            if (checked) {
                setTaxChange(true);
                // setPayableServiceList((prevList) =>
                //     prevList.map((item) => ({
                //         ...item,
                //         service_tax_percentage: ""
                //     }))
                // );
                setPaymentDetailsDataSet((prevData) => {
                    const updatedData = {
                        ...prevData,
                        no_tax: checked
                    };
                    if (checked === true) {
                        delete updatedData.is_igst_enable;
                    }

                    return updatedData;
                });

            } else {
                setTaxChange(true);
                // setPayableServiceList((prevList) =>
                //     prevList.map((item) => ({
                //         ...item,
                //         service_tax_percentage: paymentDetailsDataSet.hasOwnProperty('hotel_service_tax_data') && paymentDetailsDataSet.hotel_service_tax_data && paymentDetailsDataSet.hotel_service_tax_data.hasOwnProperty('gst_percent') && paymentDetailsDataSet.hotel_service_tax_data.gst_percent ? paymentDetailsDataSet.hotel_service_tax_data.gst_percent : ""
                //     }))
                // );
                setPaymentDetailsDataSet((prevData) => ({
                    ...prevData,
                    no_tax: false,
                    is_igst_enable: false
                }));
            }
        }
    };

    //special discount change: rate or percentage change fn
    const handelChangeSpecialDiscount = (e, type) => {
        if (type == 'rate') {
            setSpecialRateSelectedValue('rate');
            setSpecialDiscount("");
        }
        if (type == 'percentage') {
            setSpecialRateSelectedValue('percentage');
            setSpecialDiscount("");
        }
        if (type == "special_rate") {
            var expr = /^\d{0,8}(\.\d{0,2})?$/;
            if (!expr.test(e.target.value)) {
            } else {
                if (specialRateSelectedValue == "percentage") {
                    if (e.target.value == "") {
                        setSpecialDiscount("")
                    } else {
                        if (Math.abs(e.target.value) > 100) {
                            setSpecialDiscount("")
                        } else {
                            setSpecialDiscount(e.target.value)
                        }
                    }
                }
                if (specialRateSelectedValue == "rate") {
                    if (e.target.value == "") {
                        setSpecialDiscount("")
                    } else {
                        let totalAmount = tourBookingPrice.total;
                        if (Number(totalAmount) < Number(e.target.value)) {
                            setSpecialDiscount("");
                        } else {
                            setSpecialDiscount(e.target.value);
                        }
                    }
                }
            }
        }
    }

    const handlePriceChange = (e, type) => {
        if (type == "adult") {
            setSelectedTourData((prevData) => ({
                ...prevData,
                price_for_adult: e.target.value || ''
            }));
        }
        if (type == "child") {
            setSelectedTourData((prevData) => ({
                ...prevData,
                price_for_children: e.target.value || ''
            }));
        }
    }

    useEffect(() => {
        calculatePrice(specialDiscount, specialRateSelectedValue)
    }, [specialDiscount]);


    const paymentDetailsUi = () => {
        return (
            <>
                <div className="gridcontainer paymentDetailsMobileContainer">
                    <div className="modalinnerbody">
                        <div className="relativeSection row">
                            <div className="col-md-12">
                                <div className='topBtnSection'>
                                    <div className='taxButtonSection'>

                                        {/* <>
                                            <div className={paymentDetailsDataSet.hasOwnProperty('no_tax') && paymentDetailsDataSet.no_tax ? 'ist_billing_check gst-switch-btn disabled' : 'ist_billing_check gst-switch-btn'}>
                                                <label className="checkboxcontainer">CGST/SGST
                                                    <input type="checkbox" checked={paymentDetailsDataSet.hasOwnProperty('is_igst_enable') && !paymentDetailsDataSet.is_igst_enable} name="checkbox" onClick={(e) => handleChangeIgstFn(e, "cgst_sgst")} />
                                                    <span className="checkmark"></span>
                                                </label>
                                                <label className="checkboxcontainer">IGST
                                                    <input type="checkbox" checked={paymentDetailsDataSet?.is_igst_enable} name="checkbox" onClick={(e) => handleChangeIgstFn(e, "igst")} />
                                                    <span className="checkmark"></span>
                                                </label>

                                            </div>
                                            <div className='ist_billing_check gst-switch-btn hidePropertyName excludeBox'>
                                                <label className="hidePropertyContainer">Exclude TAX
                                                    <input type="checkbox" checked={paymentDetailsDataSet?.no_tax} name="checkbox" onClick={(e) => handleChangeIgstFn(e, "no_tax")} />
                                                    <span className="checkmarkhideProperty"></span>
                                                </label>
                                            </div>
                                        </> */}

                                    </div>
                                </div>
                                <div className='paymentDetailsSectionBoxScrollBox tour-group-booking-payment-details-box'>
                                    <div className='paymentDetailsSectionBox'>
                                        <div className='paymentDetailsSectionBoxDesktopView roomsSection'>
                                            <div className="paymentDetailsSectionBoxRow" >
                                                <div className="paymentDetailsSectionDateRowBox d-table">
                                                    <div className='paymentDetailsTitle tour-box'>
                                                        {Utility.capitalizeFirstLetterOfEachWord('Tour')}
                                                    </div>
                                                    <div className='paymentDetailsTitle checkin-checkout-box'>
                                                        {Utility.capitalizeFirstLetterOfEachWord('Booking Details')}<span>Check-in - Check-out</span>
                                                    </div>
                                                    <div className='paymentDetailsTitle total-duration-box'>
                                                        {Utility.capitalizeFirstLetterOfEachWord('Total Duration')}
                                                    </div>
                                                    <div className='paymentDetailsTitle price-head-box'>
                                                        {Utility.capitalizeFirstLetterOfEachWord('Price / head')} ({Utility.getCurrencySymbol(currencyName)})
                                                    </div>
                                                    <div className='paymentDetailsTitle particular'>
                                                        {Utility.capitalizeFirstLetterOfEachWord('Particular')}
                                                    </div>
                                                    <div className='paymentDetailsTitle amount text-right amountLabelSpace'>
                                                        {`${Utility.capitalizeFirstLetterOfEachWord('Amount')} (${Utility.getCurrencySymbol(currencyName)})`}
                                                    </div>
                                                </div>
                                                <div className="paymentDetailsSectionDateRowDataBox">
                                                    <div className={'paymentDetailsDataBox previousRow'} key={"123details"}>
                                                        <div className='paymentDetailsValue tour-box'>
                                                            {selectedTour?.template_name}
                                                        </div>
                                                        <div className='paymentDetailsValue checkin-checkout-box'>
                                                            {`${moment(startDate).format('DD-MM-YYYY')} - ${moment(endDate).format('DD-MM-YYYY')}`}
                                                        </div>
                                                        <div className='paymentDetailsValue total-duration-box'>{`${selectedTour?.duration}`}</div>
                                                        <div className='paymentDetailsValue editIconBox perDayRateBox price-head-box'>

                                                            {/* ₹{selectedTour?.price_for_adult} */}
                                                            <div className="input_field_inner"><strong>Adult Price:</strong> &nbsp;
                                                                <input
                                                                    name="adult_price"
                                                                    type="text"
                                                                    className="input__fields_property"
                                                                    maxlength=""
                                                                    autocomplete=""
                                                                    value={selectedTour?.price_for_adult}
                                                                    onChange={(e) => handlePriceChange(e, "adult")}
                                                                />
                                                                <div className="col-md-12 errorClass error_div"></div>
                                                            </div>

                                                            {/* ₹{selectedTour?.price_for_children} */}
                                                            <div className="input_field_inner"><strong>Child Price:</strong>&nbsp;
                                                                <input
                                                                    name="children_price"
                                                                    type="text"
                                                                    className="input__fields_property"
                                                                    maxlength=""
                                                                    autocomplete=""
                                                                    value={selectedTour?.price_for_children}
                                                                    onChange={(e) => handlePriceChange(e, "child")}
                                                                />
                                                                <div className="col-md-12 errorClass error_div"></div>
                                                            </div>
                                                        </div>
                                                        <div className='paymentDetailsValue particular'>
                                                            {/* {`${Utility.getCurrencySymbol(currencyName)} ${tourBookingPrice?.total}  */}
                                                            <span>
                                                                <strong>Adult:</strong> {Utility.getCurrencySymbol(currencyName)} {selectedTour?.price_for_adult} X {tourBookingPrice?.adultCount} = {Utility.getCurrencySymbol(currencyName)} {tourBookingPrice?.adultPrice}
                                                                {/* {`${Utility.getCurrencySymbol(currencyName)} ${tourBookingPrice?.adultPrice} @ ${tourBookingPrice?.adultCount} ${tourBookingPrice?.adultCount === 1 ? 'head' : 'heads'}`} */}
                                                            </span>
                                                            {tourBookingPrice?.childCount > 0 && (
                                                                <>
                                                                    <br />
                                                                    <span>
                                                                        <strong>Child:</strong> {Utility.getCurrencySymbol(currencyName)} {selectedTour?.price_for_children} X {tourBookingPrice?.childCount} = {Utility.getCurrencySymbol(currencyName)} {tourBookingPrice?.childPrice}
                                                                        {/* {`${Utility.getCurrencySymbol(currencyName)} ${tourBookingPrice?.childPrice} @ ${tourBookingPrice?.childCount} ${tourBookingPrice?.childCount === 1 ? 'head' : 'heads'}`} */}
                                                                    </span>
                                                                    <br />
                                                                    <span style={{
                                                                        fontSize: '10px', fontWeight: '600', fontStyle: 'inherit', color: 'red',
                                                                    }}>
                                                                        * Child price applies for age ≥ {selectedTour?.minimum_age_child_price_applied} years
                                                                    </span>
                                                                </>
                                                            )}
                                                        </div>
                                                        <div className='paymentDetailsValue amount text-right amountValueSpace'>{Utility.getCurrencySymbol(currencyName)} {Number(tourBookingPrice?.total).toFixed(2)}</div>

                                                    </div>
                                                </div>
                                            </div>

                                            <div className='singleRowBox special_discount_box for_food' style={{ display: 'none' }}>
                                                <div className='listingOption'>
                                                    <div className='chkBoxPanelList'>
                                                        <div className='special_discount_label'>Special Discount: </div>
                                                        <div className='leftBoxspecialDiscountBox'>
                                                            <label className="chkContainer">Amount
                                                                <input type="checkbox" checked={specialRateSelectedValue == 'rate' ? true : false} onChange={(e) => handelChangeSpecialDiscount(e, 'rate')} name="foodDiscount" />
                                                                <span className="checkmark"></span>
                                                            </label>
                                                            <label className="chkContainer">Percentage
                                                                <input type="checkbox" checked={specialRateSelectedValue == 'percentage' ? true : false} onChange={(e) => handelChangeSpecialDiscount(e, 'percentage')} name="foodDiscount" />
                                                                <span className="checkmark"></span>
                                                            </label>
                                                        </div>
                                                        {specialRateSelectedValue != '' && <div className='specialDiscountRow rightBoxspecialDiscountBox'>
                                                            <CustomInput
                                                                parentClassName="input_field_inner"
                                                                labelName=""
                                                                name="special_discount_food"
                                                                type="text"
                                                                value={specialDiscount}
                                                                labelPresent={false}
                                                                onChange={(e) => handelChangeSpecialDiscount(e, "special_rate")}
                                                            />
                                                        </div>}
                                                    </div>
                                                </div>
                                            </div>
                                            <>
                                                <div className='singleRowBox' style={{ display: 'none' }}>
                                                    <div className='singleRowBoxInnerLeft boldText'>
                                                        {Utility.capitalizeFirstLetterOfEachWord('Total')}:
                                                    </div>

                                                    <div className='singleRowBoxInnerRight boldText'>
                                                        {Utility.getCurrencySymbol(currencyName)} {Number(tourBookingPrice?.discountTotalAmount).toFixed(2)}
                                                    </div>
                                                </div>
                                                {tourBookingPrice?.offer_type && Number(tourBookingPrice?.offer_amount) > 0 && (
                                                    <div className='singleRowBox'>
                                                        <div className='singleRowBoxInnerLeft discount-amount'>Discount:</div>
                                                        <div className='singleRowBoxInnerRight'>{Utility.getCurrencySymbol(currencyName)}
                                                            {tourBookingPrice.offer_type === "flat"
                                                                ? Number(tourBookingPrice.offer_amount).toFixed(2)
                                                                : (
                                                                    Number(tourBookingPrice.total) * Number(tourBookingPrice.offer_amount) / 100
                                                                ).toFixed(2)
                                                            }
                                                        </div>
                                                    </div>
                                                )}
                                                {Number(tourBookingPrice?.fare_amount) > 0 && tourBookingPrice.hasOwnProperty("is_include_travel_fare") && tourBookingPrice.is_include_travel_fare && (
                                                    <div className='singleRowBox'>
                                                        <div className='singleRowBoxInnerLeft'>Travel Fare:</div>
                                                        <div className='singleRowBoxInnerRight'>{Utility.getCurrencySymbol(currencyName)} {tourBookingPrice?.fare_amount}</div>
                                                    </div>
                                                )}
                                                {paymentDetailsDataSet.hasOwnProperty('is_igst_enable') && !paymentDetailsDataSet.is_igst_enable ?
                                                    <>
                                                        {Number(tourBookingPrice?.cgstPercentage) !== 0 && <div className='singleRowBox'>
                                                            <div className='singleRowBoxInnerLeft'>CGST @ {Number(tourBookingPrice?.cgstPercentage).toFixed(2)}% :</div>
                                                            <div className='singleRowBoxInnerRight'>{Utility.getCurrencySymbol(currencyName)} {Number(tourBookingPrice?.cgstAmount).toFixed(2)}</div>
                                                        </div>}
                                                        {Number(tourBookingPrice?.sgstPercentage) !== 0 && <div className='singleRowBox'>
                                                            <div className='singleRowBoxInnerLeft'>SGST @ {Number(tourBookingPrice?.sgstPercentage).toFixed(2)}% :</div>
                                                            <div className='singleRowBoxInnerRight'>{Utility.getCurrencySymbol(currencyName)} {Number(tourBookingPrice?.sgstAmount).toFixed(2)}</div>
                                                        </div>}
                                                    </> :
                                                    paymentDetailsDataSet.hasOwnProperty('no_tax') && paymentDetailsDataSet.no_tax ? null :
                                                        <>
                                                            {Number(tourBookingPrice?.igstPercentage) !== 0 && <div className='singleRowBox'>
                                                                <div className='singleRowBoxInnerLeft'>IGST @ {Number(tourBookingPrice?.igstPercentage).toFixed(2)}% :</div>
                                                                <div className='singleRowBoxInnerRight'>{Utility.getCurrencySymbol(currencyName)} {Number(tourBookingPrice?.igstAmount).toFixed(2)}</div>
                                                            </div>}
                                                        </>
                                                }
                                                <div className='singleRowBox'>
                                                    <div className='singleRowBoxInnerLeft boldText'>{Utility.capitalizeFirstLetterOfEachWord('Total payable amount')}:</div>
                                                    <div className='singleRowBoxInnerRight boldText'>{Utility.getCurrencySymbol(currencyName)}
                                                        {
                                                            paymentDetailsDataSet.no_tax ?
                                                                (Math.round(Number(tourBookingPrice?.discountTotalAmount))).toFixed(2) :
                                                                (Math.round(Number(tourBookingPrice?.totalPayableAmount))).toFixed(2)
                                                        }</div>
                                                </div>
                                            </>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
    return (
        <>
            {paymentDetailsUi()}
        </>
    )
}

export default TourPriceDetails;

